<div class="w-full max-w-full">

  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-3xl font-bold text-gray-900 dark:text-white">Pulpit</h1>
    <p class="text-gray-600 dark:text-gray-400 mt-1">Przegląd statystyk i aktywności systemu</p>
  </div>

  <!-- Top Summary Cards - Revenue & Active Users -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
    
    <!-- Last 30 Days Revenue -->
    <div class="bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl shadow-xl p-6 text-white">
      <div class="flex items-center justify-between">
        <div class="flex-1">
          <div class="flex items-center gap-2 mb-2">
            <mat-icon class="text-white/90" [svgIcon]="'tabler_outline:currency-zloty'"></mat-icon>
            <p class="text-sm font-medium text-white/90">Przychód (ostatnie 30 dni)</p>
          </div>
          <p *ngIf="!isLoadingOverview" class="text-4xl font-bold mb-1">
            {{ formatCurrency(overviewStats?.last30DaysRevenue || 0) }} zł
          </p>
          <div *ngIf="isLoadingOverview" class="mt-2">
            <mat-spinner diameter="30" class="!text-white"></mat-spinner>
          </div>
          <p *ngIf="!isLoadingOverview && overviewStats" class="text-sm text-white/80">
            {{ overviewStats.last30DaysOrders }} opłaconych zamówień
          </p>
        </div>
        <div class="p-4 bg-white/20 backdrop-blur-sm rounded-2xl">
          <mat-icon class="text-white !w-12 !h-12" [svgIcon]="'tabler_outline:chart-line'"></mat-icon>
        </div>
      </div>
    </div>

    <!-- Active Users Last 30 Days -->
    <div class="bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl shadow-xl p-6 text-white">
      <div class="flex items-center justify-between">
        <div class="flex-1">
          <div class="flex items-center gap-2 mb-2">
            <mat-icon class="text-white/90" [svgIcon]="'tabler_outline:users'"></mat-icon>
            <p class="text-sm font-medium text-white/90">Aktywni użytkownicy (30 dni)</p>
          </div>
          <p *ngIf="!isLoadingOverview" class="text-4xl font-bold mb-1">
            {{ overviewStats?.last30DaysActiveUsers || 0 }}
          </p>
          <div *ngIf="isLoadingOverview" class="mt-2">
            <mat-spinner diameter="30" class="!text-white"></mat-spinner>
          </div>
          <p class="text-sm text-white/80">
            Unikalni użytkownicy wystawiający dokumenty
          </p>
        </div>
        <div class="p-4 bg-white/20 backdrop-blur-sm rounded-2xl">
          <mat-icon class="text-white !w-12 !h-12" [svgIcon]="'tabler_outline:activity'"></mat-icon>
        </div>
      </div>
    </div>

  </div>

  <!-- Overview Stats Cards -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-6">
    
    <!-- Total Users -->
    <div class="bg-card rounded-2xl shadow-lg p-6 border-l-4 border-blue-500">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Użytkownicy</p>
          <p *ngIf="!isLoadingOverview" class="text-3xl font-bold text-gray-900 dark:text-white mt-2">
            {{ overviewStats?.totalUsers || 0 }}
          </p>
          <div *ngIf="isLoadingOverview" class="mt-2">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
        </div>
        <div class="p-3 bg-blue-100 dark:bg-blue-900/30 rounded-full">
          <mat-icon class="text-blue-600 dark:text-blue-400 text-3xl" [svgIcon]="'tabler_outline:users'"></mat-icon>
        </div>
      </div>
      <div *ngIf="!isLoadingOverview && overviewStats" class="mt-4 text-sm">
        <span class="text-gray-600 dark:text-gray-400">Dzisiaj: </span>
        <span class="font-semibold text-gray-900 dark:text-white">{{ overviewStats.todayRegistrations }}</span>
      </div>
    </div>

    <!-- Total Documents -->
    <div class="bg-card rounded-2xl shadow-lg p-6 border-l-4 border-green-500">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Dokumenty</p>
          <p *ngIf="!isLoadingOverview" class="text-3xl font-bold text-gray-900 dark:text-white mt-2">
            {{ overviewStats?.totalDocuments || 0 }}
          </p>
          <div *ngIf="isLoadingOverview" class="mt-2">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
        </div>
        <div class="p-3 bg-green-100 dark:bg-green-900/30 rounded-full">
          <mat-icon class="text-green-600 dark:text-green-400 text-3xl" [svgIcon]="'tabler_outline:file-invoice'"></mat-icon>
        </div>
      </div>
      <div *ngIf="!isLoadingOverview && overviewStats" class="mt-4 text-sm">
        <span class="text-gray-600 dark:text-gray-400">Dzisiaj: </span>
        <span class="font-semibold text-gray-900 dark:text-white">{{ overviewStats.todayDocuments }}</span>
      </div>
    </div>

    <!-- This Month Registrations -->
    <div class="bg-card rounded-2xl shadow-lg p-6 border-l-4 border-purple-500">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Rejestracje (miesiąc)</p>
          <p *ngIf="!isLoadingOverview" class="text-3xl font-bold text-gray-900 dark:text-white mt-2">
            {{ overviewStats?.thisMonthRegistrations || 0 }}
          </p>
          <div *ngIf="isLoadingOverview" class="mt-2">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
        </div>
        <div class="p-3 bg-purple-100 dark:bg-purple-900/30 rounded-full">
          <mat-icon class="text-purple-600 dark:text-purple-400 text-3xl" [svgIcon]="'tabler_outline:user-plus'"></mat-icon>
        </div>
      </div>
      <div *ngIf="!isLoadingOverview && overviewStats" class="mt-4 flex items-center gap-2 text-sm">
        <mat-icon 
          class="text-sm" 
          [class]="getChangeClass(overviewStats.registrationsChange)"
          [svgIcon]="getChangeIcon(overviewStats.registrationsChange)">
        </mat-icon>
        <span [class]="getChangeClass(overviewStats.registrationsChange)" class="font-semibold">
          {{ overviewStats.registrationsChange > 0 ? '+' : '' }}{{ overviewStats.registrationsChange }}%
        </span>
        <span class="text-gray-600 dark:text-gray-400">vs poprzedni</span>
      </div>
    </div>

    <!-- KSeF Connections -->
    <div class="bg-card rounded-2xl shadow-lg p-6 border-l-4 border-indigo-500">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Połączony KSeF</p>
          <p *ngIf="!isLoadingOverview" class="text-3xl font-bold text-gray-900 dark:text-white mt-2">
            {{ overviewStats?.ksefConnections || 0 }}
          </p>
          <div *ngIf="isLoadingOverview" class="mt-2">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
        </div>
        <div class="p-3 bg-indigo-100 dark:bg-indigo-900/30 rounded-full">
          <mat-icon class="text-indigo-600 dark:text-indigo-400 text-3xl" [svgIcon]="'tabler_outline:plug-connected'"></mat-icon>
        </div>
      </div>
      <div *ngIf="!isLoadingOverview && overviewStats" class="mt-4 text-sm">
        <span class="text-gray-600 dark:text-gray-400">Konta z autoryzacją KSeF</span>
      </div>
    </div>

    <!-- This Month Documents (split by source) -->
    <div class="bg-card rounded-2xl shadow-lg p-6 border-l-4 border-orange-500">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Dokumenty (miesiąc)</p>
          <p *ngIf="!isLoadingOverview" class="text-3xl font-bold text-gray-900 dark:text-white mt-2">
            {{ overviewStats?.thisMonthDocuments || 0 }}
          </p>
          <div *ngIf="isLoadingOverview" class="mt-2">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
        </div>
        <div class="p-3 bg-orange-100 dark:bg-orange-900/30 rounded-full">
          <mat-icon class="text-orange-600 dark:text-orange-400 text-3xl" [svgIcon]="'tabler_outline:file-text'"></mat-icon>
        </div>
      </div>
      <div *ngIf="!isLoadingOverview && overviewStats" class="mt-4 space-y-1">
        <div class="flex items-center justify-between text-sm">
          <span class="text-gray-600 dark:text-gray-400 flex items-center gap-1">
            <span class="w-2 h-2 rounded-full bg-green-500 inline-block"></span> Lokalne
          </span>
          <span class="font-semibold text-gray-900 dark:text-white">{{ overviewStats.thisMonthLocalDocuments || 0 }}</span>
        </div>
        <div class="flex items-center justify-between text-sm">
          <span class="text-gray-600 dark:text-gray-400 flex items-center gap-1">
            <span class="w-2 h-2 rounded-full bg-violet-500 inline-block"></span> KSeF
          </span>
          <span class="font-semibold text-gray-900 dark:text-white">{{ overviewStats.thisMonthKsefDocuments || 0 }}</span>
        </div>
        <div class="flex items-center gap-2 text-sm pt-1 border-t border-gray-200 dark:border-gray-700">
          <mat-icon 
            class="text-sm" 
            [class]="getChangeClass(overviewStats.documentsChange)"
            [svgIcon]="getChangeIcon(overviewStats.documentsChange)">
          </mat-icon>
          <span [class]="getChangeClass(overviewStats.documentsChange)" class="font-semibold">
            {{ overviewStats.documentsChange > 0 ? '+' : '' }}{{ overviewStats.documentsChange }}%
          </span>
          <span class="text-gray-600 dark:text-gray-400">vs poprzedni</span>
        </div>
      </div>
    </div>

  </div>

  <!-- KSeF Sync Status Alert - widoczne TYLKO gdy są błędy -->
  <ng-container *ngIf="!isLoadingOverview && overviewStats?.ksefSync as ksefSync">
  <div class="mb-6">

    <!-- Alert: Problemy z synchronizacją KSeF -->
    <div *ngIf="ksefSync.syncFailed24h > 0 || ksefSync.authFailed7d > 0 || ksefSync.connectionsWithErrors > 0"
         class="bg-red-50 dark:bg-red-950/30 border border-red-200 dark:border-red-900/50 rounded-2xl p-6">
      <div class="flex items-start gap-4">
        <div class="p-3 bg-red-100 dark:bg-red-900/40 rounded-full flex-shrink-0">
          <mat-icon class="text-red-600 dark:text-red-400 text-3xl" [svgIcon]="'tabler_outline:alert-octagon'"></mat-icon>
        </div>
        <div class="flex-1 min-w-0">
          <h3 class="text-lg font-bold text-red-800 dark:text-red-300">Problemy z synchronizacją KSeF</h3>
          <p class="text-sm text-red-600 dark:text-red-400 mt-1">Wykryto błędy wymagające uwagi</p>

          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
            <!-- Sync Failed 24h -->
            <div class="bg-white/80 dark:bg-gray-800/50 rounded-xl p-4">
              <p class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">Błędy sync (24h)</p>
              <p class="text-2xl font-bold mt-1" 
                 [class]="ksefSync.syncFailed24h > 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'">
                {{ ksefSync.syncFailed24h }}
              </p>
            </div>

            <!-- Sync Failed 7d -->
            <div class="bg-white/80 dark:bg-gray-800/50 rounded-xl p-4">
              <p class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">Błędy sync (7 dni)</p>
              <p class="text-2xl font-bold mt-1" 
                 [class]="ksefSync.syncFailed7d > 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'">
                {{ ksefSync.syncFailed7d }}
              </p>
            </div>

            <!-- Auth Failed 7d -->
            <div class="bg-white/80 dark:bg-gray-800/50 rounded-xl p-4">
              <p class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">Błędy auth (7 dni)</p>
              <p class="text-2xl font-bold mt-1" 
                 [class]="ksefSync.authFailed7d > 0 ? 'text-amber-600 dark:text-amber-400' : 'text-green-600 dark:text-green-400'">
                {{ ksefSync.authFailed7d }}
              </p>
            </div>

            <!-- Connections with Errors -->
            <div class="bg-white/80 dark:bg-gray-800/50 rounded-xl p-4">
              <p class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">Połączenia z błędami</p>
              <p class="text-2xl font-bold mt-1" 
                 [class]="ksefSync.connectionsWithErrors > 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'">
                {{ ksefSync.connectionsWithErrors }}
              </p>
            </div>
          </div>

          <!-- Last Cron Run Summary -->
          <div *ngIf="ksefSync.lastCron as lastCron" class="mt-4 pt-4 border-t border-red-200 dark:border-red-900/50">
            <div class="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
              <span class="text-gray-600 dark:text-gray-400">
                Ostatni cron sync:
                <span class="font-medium text-gray-900 dark:text-white">{{ formatSyncDate(lastCron.timestamp) }}</span>
              </span>
              <span class="text-green-600 dark:text-green-400 font-medium">
                {{ lastCron.successCount }} OK
              </span>
              <span *ngIf="lastCron.failedCount > 0" class="text-red-600 dark:text-red-400 font-bold">
                {{ lastCron.failedCount }} FAILED
              </span>
              <span class="text-gray-500 dark:text-gray-400">
                {{ lastCron.usersProcessed }} użytkowników · {{ (lastCron.duration / 1000).toFixed(1) }}s
              </span>
            </div>

            <!-- Failed Users List -->
            <div *ngIf="lastCron.failedUsers?.length" class="mt-3 space-y-1">
              <p class="text-xs font-semibold text-red-700 dark:text-red-300 uppercase tracking-wide">Użytkownicy z błędami:</p>
              <div *ngFor="let failedUser of lastCron.failedUsers" 
                   class="flex items-start gap-2 text-xs bg-red-100/50 dark:bg-red-900/20 rounded-lg px-3 py-2">
                <mat-icon class="text-red-500 !w-4 !h-4 flex-shrink-0 mt-0.5" [svgIcon]="'tabler_outline:x'"></mat-icon>
                <div class="min-w-0">
                  <span class="font-medium text-red-800 dark:text-red-300">{{ failedUser.userLabel }}</span>
                  <span class="text-red-600 dark:text-red-400 ml-1 break-all">{{ failedUser.error }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- OK: Brak problemów -->
    <div *ngIf="ksefSync.syncFailed24h === 0 && ksefSync.authFailed7d === 0 && ksefSync.connectionsWithErrors === 0 && ksefSync.lastCron"
         class="bg-green-50 dark:bg-green-950/20 border border-green-200 dark:border-green-900/50 rounded-2xl p-4">
      <div class="flex items-center gap-3">
        <mat-icon class="text-green-600 dark:text-green-400" [svgIcon]="'tabler_outline:circle-check'"></mat-icon>
        <div>
          <span class="font-medium text-green-800 dark:text-green-300">KSeF Sync OK</span>
          <ng-container *ngIf="ksefSync.lastCron as lastCron">
            <span class="text-sm text-green-600 dark:text-green-400 ml-2">
              Ostatni sync: {{ formatSyncDate(lastCron.timestamp) }} · 
              {{ lastCron.successCount }} użytkowników · 
              {{ ksefSync.totalSyncSuccess24h }} sync(ów) w 24h
            </span>
          </ng-container>
        </div>
      </div>
    </div>

  </div>
  </ng-container>

  <!-- Register Source Statistics -->
  <div *ngIf="!isLoadingOverview && overviewStats?.registerSourceStats?.length" class="bg-card rounded-2xl shadow-lg p-6 mb-6">
    <div class="flex flex-col lg:flex-row gap-6">

      <!-- Donut Chart -->
      <div class="flex-shrink-0 lg:w-[320px]">
        <h2 class="text-xl font-semibold text-gray-900 dark:text-white flex items-center gap-2 mb-1">
          <mat-icon [svgIcon]="'tabler_outline:device-analytics'" class="text-blue-500"></mat-icon>
          Źródła rejestracji
        </h2>
        <p class="text-sm text-gray-600 dark:text-gray-400 mb-4">Z jakiej platformy zarejestrowali się użytkownicy</p>

        <!-- Przycisk backfill registerSource dla starszych kont -->
        <button mat-stroked-button color="primary" class="mb-4 w-full"
          (click)="backfillRegisterSource()"
          [disabled]="isBackfillingRegisterSource">
          <mat-icon *ngIf="!isBackfillingRegisterSource" [svgIcon]="'tabler_outline:database-import'"></mat-icon>
          <mat-spinner *ngIf="isBackfillingRegisterSource" diameter="18" class="inline-block mr-2"></mat-spinner>
          {{ isBackfillingRegisterSource ? 'Uzupełnianie...' : 'Uzupełnij źródła (stare konta)' }}
        </button>

        <apx-chart
          *ngIf="registerSourceChartConfig"
          [series]="registerSourceChartConfig.series"
          [chart]="registerSourceChartConfig.chart"
          [labels]="registerSourceChartConfig.labels"
          [colors]="registerSourceChartConfig.colors"
          [plotOptions]="registerSourceChartConfig.plotOptions"
          [dataLabels]="registerSourceChartConfig.dataLabels"
          [legend]="registerSourceChartConfig.legend"
          [tooltip]="registerSourceChartConfig.tooltip">
        </apx-chart>
      </div>

      <!-- Source Details Cards -->
      <div class="flex-1 min-w-0">
        <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 mb-6">
          <div *ngFor="let stat of overviewStats?.registerSourceStats"
               class="bg-gray-50 dark:bg-gray-800/50 rounded-xl p-4 border border-gray-200 dark:border-gray-700">
            <div class="flex items-center gap-3 mb-3">
              <div class="p-2 rounded-lg" [style.background-color]="getSourceConfig(stat.source).color + '20'">
                <mat-icon [style.color]="getSourceConfig(stat.source).color" [svgIcon]="getSourceConfig(stat.source).icon"></mat-icon>
              </div>
              <div>
                <p class="font-semibold text-gray-900 dark:text-white text-lg">{{ stat.count }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">{{ getSourceConfig(stat.source).label }} · {{ getSourcePercentage(stat.count) }}%</p>
              </div>
            </div>

            <!-- Recent users for this source -->
            <div *ngIf="stat.recentUsers?.length" class="space-y-1.5 border-t border-gray-200 dark:border-gray-700 pt-3">
              <p class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1">Ostatnie rejestracje</p>
              <div *ngFor="let user of stat.recentUsers" class="flex items-center gap-2 text-xs">
                <mat-icon class="text-gray-400 !w-3.5 !h-3.5 flex-shrink-0" [svgIcon]="'tabler_outline:user'"></mat-icon>
                <span class="text-gray-700 dark:text-gray-300 truncate" [title]="user.emailAddress">{{ user.emailAddress }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Revenue Chart -->
  <div class="bg-card rounded-2xl shadow-lg p-6 mb-6">
    <div class="mb-6">
      <div class="flex flex-col gap-4 mb-4">
        <!-- Header z tytułem -->
        <div class="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
          <div>
            <h2 class="text-xl font-semibold text-gray-900 dark:text-white flex items-center gap-2">
              <mat-icon [svgIcon]="'tabler_outline:chart-bar'" class="text-green-500"></mat-icon>
              Statystyki przychodów
            </h2>
            <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
              Przychody z opłaconych zamówień · 
              <span class="font-medium text-green-600 dark:text-green-400">
                {{ revenueGroupingMode === 'monthly' ? 'Grupowanie miesięczne' : 'Grupowanie roczne' }}
              </span>
            </p>
          </div>

          <!-- Podsumowanie -->
          <div *ngIf="!isLoadingRevenueChart && revenueSummary" class="flex flex-wrap gap-4">
            <div class="px-4 py-2 bg-green-50 dark:bg-green-900/20 rounded-xl border border-green-200 dark:border-green-800">
              <p class="text-xs text-green-600 dark:text-green-400 font-medium">Suma przychodów</p>
              <p class="text-lg font-bold text-green-700 dark:text-green-300">{{ formatCurrency(revenueSummary.totalRevenue) }} zł</p>
            </div>
            <div class="px-4 py-2 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-200 dark:border-blue-800">
              <p class="text-xs text-blue-600 dark:text-blue-400 font-medium">Liczba zamówień</p>
              <p class="text-lg font-bold text-blue-700 dark:text-blue-300">{{ revenueSummary.totalOrders }}</p>
            </div>
            <div class="px-4 py-2 bg-purple-50 dark:bg-purple-900/20 rounded-xl border border-purple-200 dark:border-purple-800">
              <p class="text-xs text-purple-600 dark:text-purple-400 font-medium">Śr. wartość zamówienia</p>
              <p class="text-lg font-bold text-purple-700 dark:text-purple-300">{{ formatCurrency(revenueSummary.averageOrderValue) }} zł</p>
            </div>
          </div>
        </div>

        <!-- Predefiniowane zakresy -->
        <div class="flex flex-wrap gap-2">
          <button
            mat-button
            [ngClass]="{
              'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 font-medium': revenueSelectedRange === 'thisYear',
              'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800': revenueSelectedRange !== 'thisYear'
            }"
            (click)="onRevenueRangeChange('thisYear')"
            class="!rounded-lg">
            <mat-icon class="mr-1" [svgIcon]="'tabler_outline:calendar'"></mat-icon>
            Ten rok
          </button>

          <button
            mat-button
            [ngClass]="{
              'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 font-medium': revenueSelectedRange === 'last12Months',
              'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800': revenueSelectedRange !== 'last12Months'
            }"
            (click)="onRevenueRangeChange('last12Months')"
            class="!rounded-lg">
            <mat-icon class="mr-1" [svgIcon]="'tabler_outline:calendar-stats'"></mat-icon>
            Ostatnie 12 miesięcy
          </button>

          <button
            mat-button
            [matMenuTriggerFor]="revenueYearsMenu"
            [ngClass]="{
              'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 font-medium': isRevenueYearSelected(),
              'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800': !isRevenueYearSelected()
            }"
            class="!rounded-lg">
            <mat-icon class="mr-1" [svgIcon]="'tabler_outline:calendar-event'"></mat-icon>
            {{ isRevenueYearSelected() ? revenueSelectedRange : 'Rok' }}
            <mat-icon class="ml-1" [svgIcon]="'tabler_outline:chevron-down'"></mat-icon>
          </button>

          <button
            mat-button
            [ngClass]="{
              'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 font-medium': revenueSelectedRange === 'last3Years',
              'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800': revenueSelectedRange !== 'last3Years'
            }"
            (click)="onRevenueRangeChange('last3Years')"
            class="!rounded-lg">
            <mat-icon class="mr-1" [svgIcon]="'tabler_outline:calendar-time'"></mat-icon>
            Ostatnie 3 lata
          </button>

          <!-- Divider -->
          <div class="border-l border-gray-300 dark:border-gray-600 mx-1"></div>

          <!-- Toggle grupowania -->
          <button
            mat-button
            (click)="onRevenueGroupingModeToggle()"
            [matTooltip]="'Przełącz tryb grupowania'"
            class="!rounded-lg bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300">
            <mat-icon [svgIcon]="revenueGroupingMode === 'monthly' ? 'tabler_outline:calendar-month' : 'tabler_outline:calendar-year'"></mat-icon>
            <span class="ml-1">{{ revenueGroupingMode === 'monthly' ? 'Miesięcznie' : 'Rocznie' }}</span>
          </button>

          <!-- Dropdown menu z latami -->
          <mat-menu #revenueYearsMenu="matMenu">
            <button 
              mat-menu-item 
              *ngFor="let year of availableYears.slice().reverse()" 
              (click)="onRevenueRangeChange(year.toString())">
              <mat-icon [svgIcon]="'tabler_outline:calendar-check'"></mat-icon>
              <span>{{ year }}</span>
            </button>
          </mat-menu>
        </div>
      </div>

      <!-- Date Range Pickers -->
      <div class="flex flex-col md:flex-row gap-4 items-end">
        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>Data początkowa</mat-label>
          <input 
            matInput 
            [matDatepicker]="revenueStartPicker" 
            [(ngModel)]="revenueStartDate"
            (dateChange)="onRevenueCustomDateChange()">
          <mat-datepicker-toggle matIconSuffix [for]="revenueStartPicker"></mat-datepicker-toggle>
          <mat-datepicker #revenueStartPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>Data końcowa</mat-label>
          <input 
            matInput 
            [matDatepicker]="revenueEndPicker" 
            [(ngModel)]="revenueEndDate"
            (dateChange)="onRevenueCustomDateChange()">
          <mat-datepicker-toggle matIconSuffix [for]="revenueEndPicker"></mat-datepicker-toggle>
          <mat-datepicker #revenueEndPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="isLoadingRevenueChart" class="flex items-center justify-center py-20">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <apx-chart
      *ngIf="!isLoadingRevenueChart && revenueChartConfig"
      [series]="revenueChartConfig.series"
      [chart]="revenueChartConfig.chart"
      [colors]="revenueChartConfig.colors"
      [plotOptions]="revenueChartConfig.plotOptions"
      [dataLabels]="revenueChartConfig.dataLabels"
      [stroke]="revenueChartConfig.stroke"
      [xaxis]="revenueChartConfig.xaxis"
      [yaxis]="revenueChartConfig.yaxis"
      [tooltip]="revenueChartConfig.tooltip"
      [legend]="revenueChartConfig.legend"
      [grid]="revenueChartConfig.grid"
      [markers]="revenueChartConfig.markers">
    </apx-chart>
  </div>

  <!-- Monthly Chart -->
  <div class="bg-card rounded-2xl shadow-lg p-6 mb-6">
    <div class="mb-6">
      <div class="flex flex-col gap-4 mb-4">
        <!-- Header z tytułem -->
        <div class="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
          <div>
            <h2 class="text-xl font-semibold text-gray-900 dark:text-white">
              Statystyki miesięczne
            </h2>
            <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
              Przegląd aktywności w wybranym okresie · 
              <span class="font-medium text-primary-600 dark:text-primary-400">
                {{ groupingMode === 'monthly' ? 'Grupowanie miesięczne' : 'Grupowanie roczne' }}
              </span>
            </p>
          </div>
        </div>

        <!-- Predefiniowane zakresy -->
        <div class="flex flex-wrap gap-2">
          <button
            mat-button
            [ngClass]="{
              'bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 font-medium': selectedRange === 'thisYear',
              'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800': selectedRange !== 'thisYear'
            }"
            (click)="onRangeChange('thisYear')"
            class="!rounded-lg">
            <mat-icon class="mr-1" [svgIcon]="'tabler_outline:calendar'"></mat-icon>
            Ten rok
          </button>

          <button
            mat-button
            [ngClass]="{
              'bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 font-medium': selectedRange === 'last12Months',
              'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800': selectedRange !== 'last12Months'
            }"
            (click)="onRangeChange('last12Months')"
            class="!rounded-lg">
            <mat-icon class="mr-1" [svgIcon]="'tabler_outline:calendar-stats'"></mat-icon>
            Ostatnie 12 miesięcy
          </button>

          <button
            mat-button
            [matMenuTriggerFor]="yearsMenu"
            [ngClass]="{
              'bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 font-medium': isYearSelected(),
              'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800': !isYearSelected()
            }"
            class="!rounded-lg">
            <mat-icon class="mr-1" [svgIcon]="'tabler_outline:calendar-event'"></mat-icon>
            {{ isYearSelected() ? selectedRange : 'Rok' }}
            <mat-icon class="ml-1" [svgIcon]="'tabler_outline:chevron-down'"></mat-icon>
          </button>

          <button
            mat-button
            [ngClass]="{
              'bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 font-medium': selectedRange === 'last3Years',
              'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800': selectedRange !== 'last3Years'
            }"
            (click)="onRangeChange('last3Years')"
            class="!rounded-lg">
            <mat-icon class="mr-1" [svgIcon]="'tabler_outline:calendar-time'"></mat-icon>
            Ostatnie 3 lata
          </button>

          <!-- Divider -->
          <div class="border-l border-gray-300 dark:border-gray-600 mx-1"></div>

          <!-- Toggle grupowania -->
          <button
            mat-button
            (click)="onGroupingModeToggle()"
            [matTooltip]="'Przełącz tryb grupowania'"
            class="!rounded-lg bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300">
            <mat-icon [svgIcon]="groupingMode === 'monthly' ? 'tabler_outline:calendar-month' : 'tabler_outline:calendar-year'"></mat-icon>
            <span class="ml-1">{{ groupingMode === 'monthly' ? 'Miesięcznie' : 'Rocznie' }}</span>
          </button>

          <!-- Dropdown menu z latami -->
          <mat-menu #yearsMenu="matMenu">
            <button 
              mat-menu-item 
              *ngFor="let year of availableYears.slice().reverse()" 
              (click)="onRangeChange(year.toString())">
              <mat-icon [svgIcon]="'tabler_outline:calendar-check'"></mat-icon>
              <span>{{ year }}</span>
            </button>
          </mat-menu>
        </div>
      </div>

      <!-- Date Range Pickers -->
      <div class="flex flex-col md:flex-row gap-4 items-end">
        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>Data początkowa</mat-label>
          <input 
            matInput 
            [matDatepicker]="startPicker" 
            [(ngModel)]="startDate"
            (dateChange)="onCustomDateChange()">
          <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>Data końcowa</mat-label>
          <input 
            matInput 
            [matDatepicker]="endPicker" 
            [(ngModel)]="endDate"
            (dateChange)="onCustomDateChange()">
          <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="isLoadingMonthlyChart" class="flex items-center justify-center py-20">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <apx-chart
      *ngIf="!isLoadingMonthlyChart && monthlyChartConfig"
      [series]="monthlyChartConfig.series"
      [chart]="monthlyChartConfig.chart"
      [colors]="monthlyChartConfig.colors"
      [plotOptions]="monthlyChartConfig.plotOptions"
      [dataLabels]="monthlyChartConfig.dataLabels"
      [stroke]="monthlyChartConfig.stroke"
      [xaxis]="monthlyChartConfig.xaxis"
      [yaxis]="monthlyChartConfig.yaxis"
      [fill]="monthlyChartConfig.fill"
      [tooltip]="monthlyChartConfig.tooltip"
      [legend]="monthlyChartConfig.legend"
      [grid]="monthlyChartConfig.grid">
    </apx-chart>
  </div>

  <!-- Register Source Time Chart -->
  <div class="bg-card rounded-2xl shadow-lg p-6 mb-6">
    <div class="mb-6">
      <h2 class="text-xl font-semibold text-gray-900 dark:text-white">Źródła rejestracji w czasie</h2>
      <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
        Rejestracje per urządzenie · zakres zgodny ze statystykami miesięcznymi
      </p>
    </div>

    <div *ngIf="isLoadingRegisterSourceChart" class="flex items-center justify-center py-20">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <apx-chart
      *ngIf="!isLoadingRegisterSourceChart && registerSourceTimeChartConfig"
      [series]="registerSourceTimeChartConfig.series"
      [chart]="registerSourceTimeChartConfig.chart"
      [colors]="registerSourceTimeChartConfig.colors"
      [plotOptions]="registerSourceTimeChartConfig.plotOptions"
      [dataLabels]="registerSourceTimeChartConfig.dataLabels"
      [stroke]="registerSourceTimeChartConfig.stroke"
      [xaxis]="registerSourceTimeChartConfig.xaxis"
      [yaxis]="registerSourceTimeChartConfig.yaxis"
      [fill]="registerSourceTimeChartConfig.fill"
      [tooltip]="registerSourceTimeChartConfig.tooltip"
      [legend]="registerSourceTimeChartConfig.legend"
      [grid]="registerSourceTimeChartConfig.grid">
    </apx-chart>
  </div>

  <!-- Daily Chart -->
  <div class="bg-card rounded-2xl shadow-lg p-6">
    <div class="mb-6">
      <h2 class="text-xl font-semibold text-gray-900 dark:text-white">Aktywność dzienna</h2>
      <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">Ostatnie 30 dni</p>
    </div>

    <div *ngIf="isLoadingDailyChart" class="flex items-center justify-center py-20">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <apx-chart
      *ngIf="!isLoadingDailyChart && dailyChartConfig"
      [series]="dailyChartConfig.series"
      [chart]="dailyChartConfig.chart"
      [colors]="dailyChartConfig.colors"
      [fill]="dailyChartConfig.fill"
      [dataLabels]="dailyChartConfig.dataLabels"
      [stroke]="dailyChartConfig.stroke"
      [xaxis]="dailyChartConfig.xaxis"
      [yaxis]="dailyChartConfig.yaxis"
      [tooltip]="dailyChartConfig.tooltip"
      [legend]="dailyChartConfig.legend"
      [grid]="dailyChartConfig.grid">
    </apx-chart>
  </div>

</div>
